// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"fb8791cc","223":"ea92dc40","293":"c9f92993","453":"4c84d9bc","608":"817c3949","836":"a4b88824"}[chunkId] + ".chunk.js";
};